module.exports = __webpack_public_path__ + "static/media/pratham_tandale.8bd1e7fa.png";